import React, { useState, useEffect, useContext, useRef } from 'react'
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom'
//import { motion } from "framer-motion"
//import { animationOne, transition } from '../../animations'
import { AuthContext } from '../../App.js'

import './index.css'
import Header from '../Header'
import Menu from '../Menu'
import { Button } from '@material-ui/core'
import COLORS  from '../../colors'
import { ReactComponent as Dots } from '../../assets/dots.svg'
import { ReactComponent as WaterSign } from '../../assets/watersign.svg'
import { ReactComponent as Bag } from '../../assets/bag.svg'
import { useSwipeable } from 'react-swipeable' 
import { isMobile } from 'react-device-detect'
 
 
var tapedTwice = false
var isBack=false
var taped=false
var runTap=false
 
const Main = ({ creds, rank, prevPage}) => {

      const { setPageNumber, signOut } = useContext(AuthContext)
      const params = useParams()
      const navigate = useNavigate()
      // setup ref for your usage
      const myRef = useRef();
   
      const handlers = useSwipeable({onSwipedRight:()=>handleRightSwipe() })
            //, onSwipedDown:()=>handleDownSwipe()
      const handleDownSwipe = (e) => {
            e.preventDefault()
            e.stopPropagation()
            // if(!tapedTwice){
            //       document.querySelector(".rootBody").style.overscrollBehaviorY='contain'
            //       tapedTwice=true
            //       setTimeout( function() { tapedTwice=false; }, 2000 );
            // }else if(tapedTwice){ 
            //       document.querySelector(".rootBody").style.overscrollBehaviorY='auto'
            // }
            return false
             
      }

      const handleRightSwipe = () => {
            if(prevPage===1){
                  setPageNumber(1)
                  setTimeout(() => navigate(`/kekspos/${params.tid}/qr-iznos`), 0)
            }else if(prevPage===3){
                  setPageNumber(3)
                  setTimeout(() => navigate(`/kekspos/${params.tid}/povijest-transakcija`), 0)
            }else if(prevPage===5){
                  setPageNumber(5)
                  setTimeout(() => navigate(`/kekspos/${params.tid}/qr-artikl`), 0)
            }else if(prevPage===7){
                  setPageNumber(7)
                  setTimeout(() => navigate(`/kekspos/${params.tid}/izvjestaji`), 0) 
            }else if(prevPage===8){
                  setPageNumber(8)
                  setTimeout(() => navigate(`/kekspos/${params.tid}/admin-artikl`), 0)  
            }else if(prevPage===9){
                  setPageNumber(9)
                  setTimeout(() => navigate(`/kekspos/${params.tid}/admin-korisnik`), 0)
            }else if(prevPage===15){
                  setPageNumber(15)
                  setTimeout(() => navigate(`/kekspos/${params.tid}/uvjeti-koristenja`), 0)
            }
      }
    
      const refPassthrough = (el) => {
            // call useSwipeable ref prop with el
            handlers.ref(el)
            // set myRef el so you can access it yourself
            myRef.current = el
      }

   
//      const handleTap = (e) => {
//             e.preventDefault()
            
//             if(!tapedTwice){
//                   document.querySelector(".rootBody").style.overscrollBehaviorY='contain'
//                   tapedTwice=true
//                   window.setTimeout( function() { tapedTwice=false; }, 1500 );
                   
//                   return false;
//             } 
             
//      }

     
      
    

      // const handleReloadd  = async (event) => 
      // {
           
      //       console.log("visibility: "+ event.type)
              
      //       setTimeout(() => window.location.assign(`/kekspos/?token=${creds.token}`), 0)
      //       event.preventDefault();
            
      // }
      

//      const handleTap = (e) => {
//             e.preventDefault()
      
//             if(!tapedTwice){
                  
//                   document.querySelector(".rootBody").style.overscrollBehaviorY='contain'
//                   tapedTwice=true
                 
//                   window.setTimeout( function() { tapedTwice=false; runTap=false; }, 1000 );
                  
//                   return false;
//             }else{
//                   if(!runTap){
//                         runTap=true
//                         window.setTimeout( function() { document.querySelector(".rootBody").style.overscrollBehaviorY='auto';  }, 0 );  
//                   } 
//             }
       
// //       }

//      const handleTapEnd = () => {
//             if(!taped){
//                   //document.querySelector(".rootBody").style.overscrollBehaviorY='auto'; 
//                   taped=true
//             }else{
//                   document.querySelector(".rootBody").style.overscrollBehaviorY='auto'; 
//                   taped=false
//             }
//      }

      const onBackButtonEvent = (e) => {
                   
            console.log("-----------------------------you will be sign out---------------------------")
            isBack=true
            e.preventDefault()
            signOut(creds.cid)
            setTimeout(()=>window.location.replace(`/kekspos`), 0)
            //setTimeout(()=>navigate(`/kekspos/?cid=${creds.cid}`), 0)
      }

      const [test, setTest] = useState("")

      function sleep(delay) {
            var start = new Date().getTime();
            while (new Date().getTime() < start + delay);

            return true
          }

      useEffect(() => 
      {   
            setTest("NOT EMPTY")
            const handleReload = async (e) => 
            {
                 
                  // navigator.serviceWorker.getRegistrations().then((registrations) => {
                  //       registrations.forEach((registration) => {
                  //             registration.unregister();
                  //       });
                  // });

                  // caches.keys().then((keyList) => {
                  //       return Promise.all(
                  //         keyList.map((key) => {
                  //               console.log(key)
                  //           return caches.delete(key);
                  //         })
                  //       );
                  // });

                  // const data = 'page-closed';
                  // navigator.sendBeacon('/analytics', data);

                  //setTimeout(() => window.location.replace(`/kekspos/?token=${creds.token}`), 0)
                  //setTimeout(()=>navigate(`/kekspos/${params.tid}`), 0)
                  
                  
                  e.preventDefault()
                
                  
                  setTimeout(() => window.location.assign(`/kekspos`, 0));
                  
                  //setTimeout(() => window.location.href=getHostName() + `/kekspos/?token=${creds.token}`, 0);
                  window.removeEventListener('beforeunload', handleReload)
                  // e.returnValue = 'Are you sure you wish to leave?';
                  return false
                  
                   
                  //return e.returnValue="You have reload?"
                  //return false
            }

            window.addEventListener("beforeunload", handleReload)
        
           //window.addEventListener("submit", handleReload)
            
  		  
            return () => 
            {    
                window.removeEventListener('beforeunload', handleReload) 
                window.removeEventListener('submit', handleReload) 
            }
  
  	}, [])
     
       

      useEffect(() => 
      {  
            window.addEventListener('popstate', onBackButtonEvent)
           // window.addEventListener("touchstart", handleTap, false)
            //window.addEventListener("touchmove", handleMove, false)
            //window.addEventListener("touchend", handleTapEnd, false)
            //window.addEventListener("focus", handleFocus, false)
             return () => 
             {    
                  // window.removeEventListener('touchstart', handleTap) 
                   // window.removeEventListener('touchmove', handleMove) 
                   //window.removeEventListener('touchend', handleTapEnd)
                   window.removeEventListener('popstate', onBackButtonEvent)    
                   //window.removeEventListener("focus", handleFocus)
  	       }
            
  	}, [])

  return (
    //<motion.div  initial="out" animate="in" exit="out" variants={animationOne} transition={transition}>
    <div className="main" {...handlers} ref={refPassthrough}>
    	<Header pageNumber={null}/>
      <div>
        <div className="title-qr">
        	<span className="title-qr-txt">KREIRAJ QR KOD ZA NAPLATU</span>
        	<span className="title-qr-subtxt" >Brzo kreiraj QR kod za naplatu računa KEKS Pay korisnicima. Možeš kreirati QR kod prema željenom ukupnom iznosu računa ili možeš odabirati već prije unešene artikle i na taj način generirati QR kod.</span>
        </div>
        <div className='qr-btn-group'>
        <Button  size="large" 
                 variant="contained"
                 component={Link}
                 to='qr-iznos'
                 style={{ width:!isMobile?'25rem':'90%',
                          justifyContent:'space-between',
                          color:"#fff", 
                          fontWeight:'bold', 
                          backgroundColor: COLORS.green, 
                          margin:5, 
                          textTransform:'none',
                          textDecoration: 'none'
                       }} 
                  startIcon={<Dots style={{width:36, height:36, marginLeft: -5}} />} 
                  endIcon={<WaterSign style={{width:55, height:55, marginTop:-25, marginLeft:20, marginRight:-5}}/>}
                  onClick={() => setPageNumber(1)}
         ><div className="btn-txt"><span className="btn-span-txt1">Kreiraj QR kod</span><span className="btn-span-subtxt"> SA IZNOSOM</span></div></Button>
        <Button size="large" 
                variant="contained"
                component={Link}
                to='qr-artikl' 
        	      style={{
                   width:!isMobile?'25rem':'90%',  
        		       justifyContent:'space-between', 
                   color:"#fff", 
        		       fontWeight: 'bold', 
        		       backgroundColor: COLORS.green,
        		       margin: 5, 
                   textTransform: 'none',
                   textDecoration: 'none'
                  }} 
                startIcon={<Bag style={{width:33, height:33, marginLeft: -5}} />} 
                endIcon={<WaterSign style={{width:55, height:55, marginTop:-21, marginLeft:20, marginRight:-5}}/>}  			 
                onClick={() => setPageNumber(5)}
        ><div className="btn-txt"><span className="btn-span-txt2">Kreiraj QR kod</span> <span className="btn-span-subtext">SA ARTIKLIMA</span></div></Button>
   	</div>
   	<Menu cid={creds.cid} rank={rank}/>
     </div>
    </div>
    // </motion.div>
  )
}

export default Main
